module.exports = {
  1: 19341464,
  56: 36593146,
  97: 38543402,
  137: 54144778,
  8453: 11289587,
  17000: 1132433,
  42161: 186290627,
  43113: 30844328,
  43114: 42345669,
  59140: 4286115,
  59144: 2613444,
  80001: 47001356,
  84532: 7287254,
  421614: 22800328,
  11155111: 5395281,
  245022926: 308306064,
  245022934: 277791952,
}
